<template>
  <div>
    <div class="header" :class="{ 'game-header': activeMenu == '/game' }">
      <div class="logobox">
        <DIV class="menu" @click="showMenu = !showMenu">
          <img src="@/assets/image/menu.png" alt="" />
        </DIV>
        <!-- <div class="logo">
          <img src="@/assets/image/logo.png" alt="" />
        </div> -->
      </div>

      <div class="secretbox">
        <WalletConnector></WalletConnector>
        <!-- <popover v-model="showPopover" placement="bottom-end" trigger="click" theme="dark" :actions="actions"
          @select="onLangSelect">
          <template #reference>
            <div class="lang">
              <i class="iconfont icon-language1" style="font-size: 20px;"></i>
            </div>
          </template>
</popover> -->
      </div>
    </div>
    <div class="pop-box">
      <div v-if="showMenu" class="mask" :style="{ opacity: showMenu ? '.5' : '0' }" @click="_hideTapHandle" />
      <div :class="{ on: showMenu }" class="content" catchtouchmove="true">
        <div class="wrap">
          <i class="iconfont icon-v2_close closebtn" @click="showMenu = false" />
          <div class="main">
            <ul class="menubox">
              <li :class="{ active: activeMenu == '/home' }">
                <router-link to="/home">
                  首页
                </router-link>
              </li>
              <li :class="{ active: activeMenu == '/pledge' }">
                <router-link to="/pledge">
                  RAD/BOX质押生态
                </router-link>
              </li>
              <li :class="{ active: activeMenu == '/rad-to-ai' }">
                <router-link to="/rad-to-ai">
                  RAD兑换Ai算法龙虾燃料
                </router-link>
              </li>
              <li :class="{ active: activeMenu == '/rusd-defi' }">
                <router-link to="/rusd-defi">
                  RUSD增值稳定币DEFI
                </router-link>
              </li>
              <li :class="{ active: activeMenu == '/chain-game' }">
                <router-link to="/chain-game">
                  链上游戏生态
                </router-link>
              </li>
              <li :class="{ active: activeMenu == '/chain-mall' }">
                <router-link to="/chain-mall">
                  链上商城生态
                </router-link>
              </li>
              <li :class="{ active: activeMenu == '/share-swap' }">
                <router-link to="/share-swap">
                  币股同权兑换
                </router-link>
              </li>
              <li v-if="isAdmin" :class="{ active: activeMenu == '/admin' }">
                <router-link to="/admin">
                  管理员页面
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- v-if="selectAddress" -->
    <div class="main">
      <router-view />
    </div>

  </div>
</template>

<script>
import { Popover } from 'vant';
import WalletConnector from "@/components/WalletConnector.vue";
export default {
  components: {
    Popover,
    WalletConnector
  },
  watch: {
    
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      this.showMenu = false;
      return path;
    },
    selectAddress() {
      return this.$store.getters.accountAddress;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  data() {
    return {
      showMenu: false,
      showPopover: false,
      locale: localStorage.getItem("locale") || "en",
     
      // 通过 actions 属性来定义菜单选项
      actions: [{ text: 'English', value: 'en' }, { text: '简体中文', value: 'zh' }],
    };
  },
  async created() { },
  methods: {
    
    _hideTapHandle() {
      if (!this.showMenu) return;
      this.showMenu = false;
    },
    onLangSelect(action) {
      console.log(action);
      let locale = action.value;
      this.$i18n.locale = locale;
      this.locale = locale;
      localStorage.setItem("locale", locale);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;
  color: #fff;
  background-color: rgba($color: #000, $alpha: 0.5);
  backdrop-filter: blur(10px);
  height: 160px;

  .logobox {
    display: flex;
    align-items: center;

    .menu {
      width: 7.33vw;
      display: flex;
      align-items: center;

      img {
        width: 100%;
      }
    }

    .logo {
      width: 8.33vw;
      display: flex;
      align-items: center;
      margin-left: 3vw;

      img {
        width: 100%;
      }
    }
  }



}

.menubox {
  font-size: 20px;
  margin-top: 30px;

  img {
    width: 5.33vw;
  }

  a {
    display: block;
    width: 100%;
    height: 100%;
    color: #66676a;
    font-size: 18px;
    display: flex;
    align-items: center;
    border-radius: 12px 12px 12px 12px;
    padding: 0 20px;
    box-sizing: border-box;
  }
}

.pop-box .mask {
  background: rgba(0, 0, 0);
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  opacity: 0;
  transition: all 0.3s;
}

.pop-box .wrap {
  width: 100%;
  height: 100%;
  position: relative;
}

.pop-box .content {
  height: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 10001;
  background-color: rgba($color: #000, $alpha: 0.5);
  backdrop-filter: blur(10px);
  box-sizing: border-box;
  transform: translate3d(-100%, 0, 0);
  transition: transform 0.3s;
  overflow: hidden;
}

.pop-box .content.on {
  transform: translate3d(0, 0, 0);
  transition: transform 0.3s;
}

.pop-box .wrap {
  position: relative;
  height: 100%;
  width: 500px;
  padding: 16px 16px 0;

  .main {
    height: 100%;

    .min-logo {
      margin: 30px 16px;
      width: 30vw;

      img {
        width: 100%;
        height: auto;
      }
    }
  }
}

.pop-box .closebtn {
  font-size: 40px;
  position: absolute;
  right: 36px;
  top: 32px;
  color: #fff;
  z-index: 12;
  cursor: pointer;
}

.menubox li {
  min-height: 120px;
  font-size: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.22);
}

.menubox li i {
  margin-right: 16px;
  font-size: 40px;
  color: rgba(#333, 0.4);
}

.menubox li a {
  color: #fff;
  font-size: 28px;
  line-height: 1.4;
  padding: 24px 20px;
}

.menubox li.active a {
  //   background-color: #e28317;
  color: #7338ff;

  i {
    color: #fff;
  }
}
</style>
